export default __webpack_public_path__ + "assets/poll_detail.837cfb7a.svg";